import { withAuthenticationRequired } from "@auth0/auth0-react";

import ErrorBoundaryWrapper from "./components/ErrorBoundary";

const AuthenticationGuard = ({ component }) => {
   return <ErrorBoundaryWrapper>{component}</ErrorBoundaryWrapper>;
};

export default withAuthenticationRequired(AuthenticationGuard, {
   onRedirecting: () => null
});
